/* eslint-disable no-extra-boolean-cast */
import { toLocaleCurrency } from 'utils/dinero'

import { THOUSAND } from 'constants/credit'
import { Dispatch, RefObject, SetStateAction } from 'react'

interface ProgressBarProps {
  value: string | number
  maxValue: string | number
  setValue?: Dispatch<SetStateAction<string | number>>
  inputRef?: RefObject<HTMLInputElement>
  minValue?: string | number
  className?: string
  divider?: number
  bgClassName?: string
}

const ProgressBar = ({
  value,
  maxValue,
  inputRef = null,
  setValue = () => null,
  minValue = 0,
  divider = THOUSAND,
  className = '',
  bgClassName = ''
}: ProgressBarProps) => {
  const percentage = Math.min(
    Math.floor((100 * Number(value)) / (Number(maxValue) - Number(minValue))),
    100
  )

  const isError = value > maxValue || maxValue === 0

  return (
    <div className='flex w-full font-bold text-2xs text-gray-900 gap-2 items-baseline'>
      {!!inputRef && (
        <button
          type='button'
          onClick={() => setValue((Number(minValue) / divider).toString())}
          className='font-bold'
        >
          $ {toLocaleCurrency(minValue)}
        </button>
      )}
      <div
        className={`bg-gray-300 h-1 flex-grow rounded ${className}`}
        aria-valuemin={Number(minValue)}
        aria-valuemax={Number(maxValue)}
        aria-valuenow={Number(value)}
      >
        <div
          className={`rounded bg-green-800 transition-all ease-in-out duration-1000 h-full animate-pulse ${
            !!isError && 'bg-red-100'
          } ${bgClassName}`}
          style={{
            width: `${percentage}%`
          }}
        />
      </div>
      {inputRef && (
        <button
          type='button'
          onClick={() => setValue((Number(maxValue) / divider).toString())}
          className='font-bold'
        >
          $ {toLocaleCurrency(maxValue)}
        </button>
      )}
    </div>
  )
}

export default ProgressBar
